import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=0b5a7d0c&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=0b5a7d0c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5a7d0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5a7d0c')) {
      api.createRecord('0b5a7d0c', component.options)
    } else {
      api.reload('0b5a7d0c', component.options)
    }
    module.hot.accept("./comment.vue?vue&type=template&id=0b5a7d0c&scoped=true", function () {
      api.rerender('0b5a7d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blog/comment.vue"
export default component.exports